import AnxAlert from "./AnxAlert/AnxAlert.vue";
import AnxButton from "./AnxButton/AnxButton.vue";
import AnxCard from "./AnxCard/AnxCard.vue";
import AnxCheckbox from "./AnxCheckbox/AnxCheckbox.vue";
import AnxContact from "./AnxContact/AnxContact.vue";
import AnxContainer from "./AnxContainer/AnxContainer.vue";
import AnxContent from "./AnxContent/AnxContent.vue";
import AnxCrudTable from "./AnxCrudTable/AnxCrudTable.vue";
import AnxFooter from "./AnxFooter/AnxFooter.vue";
import AnxForm from "./AnxForm/AnxForm.vue";
import AnxFormContainer from "./AnxFormContainer/AnxFormContainer.vue";
import AnxGlobal from "./AnxGlobal/AnxGlobal.vue";
import AnxHeader from "./AnxHeader/AnxHeader.vue";
import AnxHrLine from "./AnxHrLine/AnxHrLine.vue";
import AnxIcon from "./AnxIcon/AnxIcon.vue";
import AnxInput from "./AnxInput/AnxInput.vue";
import AnxLink from "./AnxLink/AnxLink.vue";
import AnxList from "./AnxList/AnxList.vue";
import AnxLogin from "./AnxLogin/AnxLogin.vue";
import AnxLanguageSwitcher from "./AnxLanguageSwitcher/AnxLanguageSwitcher.vue";
import AnxModal from "./AnxModal/AnxModal.vue";
import AnxParagraph from "./AnxParagraph/AnxParagraph.vue";
import AnxReadonly from "./AnxReadonly/AnxReadonly.vue";
import AnxSelect from "./AnxSelect/AnxSelect.vue";
import AnxTable from "./AnxTable/AnxTable.vue";
import AnxTableCol from "./AnxTableCol/AnxTableCol.vue";
import AnxTableContainer from "./AnxTableContainer/AnxTableContainer.vue";
import AnxTableRow from "./AnxTableRow/AnxTableRow.vue";
import AnxTextarea from "./AnxTextarea/AnxTextarea.vue";
import AnxTitle from "./AnxTitle/AnxTitle.vue";
import AnxToast from "./AnxToast/AnxToast.vue";
import AnxToaster from "./AnxToaster/AnxToaster.vue";

// Default export
export default {
  AnxAlert,
  AnxButton,
  AnxCard,
  AnxCheckbox,
  AnxContact,
  AnxContainer,
  AnxContent,
  AnxCrudTable,
  AnxFooter,
  AnxForm,
  AnxFormContainer,
  AnxGlobal,
  AnxHeader,
  AnxHrLine,
  AnxIcon,
  AnxInput,
  AnxLanguageSwitcher,
  AnxLink,
  AnxList,
  AnxLogin,
  AnxModal,
  AnxParagraph,
  AnxReadonly,
  AnxSelect,
  AnxTable,
  AnxTableCol,
  AnxTableContainer,
  AnxTableRow,
  AnxTextarea,
  AnxTitle,
  AnxToast
};

// Exporting components separately
export {
  AnxAlert,
  AnxButton,
  AnxCard,
  AnxCheckbox,
  AnxContact,
  AnxContainer,
  AnxContent,
  AnxCrudTable,
  AnxFooter,
  AnxForm,
  AnxFormContainer,
  AnxGlobal,
  AnxHeader,
  AnxHrLine,
  AnxIcon,
  AnxInput,
  AnxLanguageSwitcher,
  AnxLink,
  AnxList,
  AnxLogin,
  AnxModal,
  AnxParagraph,
  AnxReadonly,
  AnxSelect,
  AnxTable,
  AnxTableCol,
  AnxTableContainer,
  AnxTableRow,
  AnxTextarea,
  AnxTitle,
  AnxToast,
  AnxToaster
};
